var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"button icon-button"},_vm.$listeners),[_c('font-awesome-icon',{class:_vm.iconClass,attrs:{"icon":_vm.icon,"size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }